module.exports = __webpack_public_path__ + "web/img/sign.37bafdcf.png";